import * as React from "react";
import { z } from "zod";
import styled from "styled-components";
import { MediaPromosListBladeSchema } from "../../../schemas/blades/MediaPromosList";
import { Blade } from "../../../components/Blade";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { BladeContent } from "../../../components/BladeContent";
import { BladeHeaderCentered } from "../../../molecules/BladeHeaderCentered";
import { AnalyticsProvider } from "../../../providers/AnalyticsProvider";
import { Carousel, CarouselViewport, CarouselSlides, CarouselProgressBar, CarouselControls, CarouselNext, CarouselPrevious, } from "../../../components/Carousel";
import { MediaPromoSlide } from "..";
import { Backdrop, BackdropBackground } from "../../../components/Backdrop";
import { Media, MediaType } from "../../../components/Media";
export const LandingPromoCardCarouselContractSchema = MediaPromosListBladeSchema.extend({
    type: z.literal("landingPromoCardCarousel"),
});
const _LandingPromoCardCarousel = ({ backdrop, header, items, ...props }) => {
    const { background } = backdrop || {};
    return (React.createElement(Blade, { "data-testid": "promo-card-carousel", ...props },
        React.createElement(Backdrop, null,
            React.createElement(BackdropBackground, null, background?.type === MediaType.IMAGE && (React.createElement(Media, { "data-testid": "backdrop-background-image", media: background, role: "presentation" })))),
        React.createElement(BladeHeaderCentered, { ...header }),
        React.createElement(BladeContent, { width: "large" },
            React.createElement(AnalyticsProvider, { uiLocation: "carousel" },
                React.createElement(Carousel, { draggable: true },
                    React.createElement(CarouselViewport, null,
                        React.createElement(CarouselSlides, null, items.map((item, index) => (React.createElement(MediaPromoSlide, { content: item, slideIndex: index, slideTotal: items.length, key: index }))))),
                    React.createElement(CarouselControls, null,
                        React.createElement(CarouselProgressBar, null),
                        React.createElement("div", { className: "trigger-wrapper" },
                            React.createElement(CarouselPrevious, null),
                            React.createElement(CarouselNext, null))))))));
};
export const LandingPromoCardCarousel = styled(_LandingPromoCardCarousel) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=LandingPromoCardCarousel.js.map